import React from "react";

export const CountryLabel = (props:{name:string})=>{
    return <span className='everyones-smile-country-text'>{props.name}</span>;
};